import { render, staticRenderFns } from "./listarDiagnostico.vue?vue&type=template&id=a16880ba&scoped=true&"
import script from "./listarDiagnostico.vue?vue&type=script&lang=js&"
export * from "./listarDiagnostico.vue?vue&type=script&lang=js&"
import style0 from "./listarDiagnostico.vue?vue&type=style&index=0&id=a16880ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16880ba",
  null
  
)

export default component.exports